type RebateIconProps = React.SVGProps<SVGSVGElement>;

const RebateIcon: React.FC<RebateIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="-17.5 -15.5 100 100"
      fill="none"
      {...props}
    >
      <path
        d="M5.38458 23.4618L33.2417 40.1761V68.0332L5.38458 51.3189V23.4618Z"
        fill="#DDB96E"
      />
      <path
        d="M33.242 37.0962L44.5833 24.8452L58.9011 23.888V51.7451L33.242 68.0318V37.0962Z"
        fill="#7C612E"
      />
      <path
        d="M0.732751 26.4321L30.268 43.4121L44.8381 26.3834L15.566 8.74829L0.732751 26.4321Z"
        fill="#F2D497"
      />
      <path
        d="M0.732778 26.4358L30.268 43.4157L30.2681 44.5605L0.732666 27.5899L0.732778 26.4358Z"
        fill="#F2D497"
      />
      <path
        d="M44.841 26.386L30.265 43.4134L30.265 44.5581L44.8409 27.5401L44.841 26.386Z"
        fill="#F2D497"
      />
      <path
        d="M44.8442 26.3861L63.4992 24.4092L63.4993 25.5539L44.8441 27.5402L44.8442 26.3861Z"
        fill="#F2D497"
      />
      <path
        d="M33.9127 6.98022L63.4999 24.4098L44.8543 26.405L15.5635 8.76593L33.9127 6.98022Z"
        fill="#F9E4B9"
      />
      <path
        d="M40.1854 15.3682H40.1893L47.6561 19.7715L42.8943 20.29L35.5711 15.8799L35.574 15.8789L29.5789 12.2695L34.1668 11.8232L40.1854 15.3682Z"
        fill="#7C612E"
      />
      <path
        d="M34.1651 11.8253V15.0316L29.5778 12.2717L34.1651 11.8253Z"
        fill="#7C612E"
      />
      <path
        d="M31.6911 16.1088C31.2072 7.8255 34.2142 3.13817 39.1983 3.89207e-05L49.249 6.10091C44.8446 8.98822 42.3507 13.8836 42.6504 22.7148L31.6911 16.1088Z"
        fill="#F2D497"
      />
      <path
        d="M33.0189 16.3493C32.5007 9.98505 34.8668 4.72 39.1977 2.07724L46.3464 6.41586C44.6964 7.75741 43.3956 9.83174 42.507 12.3298C41.5926 14.9006 41.1007 17.953 41.1169 21.2009L33.0189 16.3493Z"
        stroke="#BB9446"
      />
      <path
        d="M39.0502 8.92679C40.94 9.6894 41.8552 11.6492 41.2053 13.2601C40.5553 14.8709 38.5362 15.6465 36.6463 14.8839C34.7566 14.1211 33.8421 12.1618 34.4921 10.551C35.1422 8.94033 37.1605 8.16441 39.0502 8.92679Z"
        fill="#BB9446"
        stroke="#BB9446"
        strokeWidth="0.75"
      />
      <path
        d="M34.9912 11.0406L35.2072 10.5528L35.8021 10.8162C35.893 10.643 36.0091 10.5093 36.1549 10.3889C36.3179 10.2618 36.477 10.1757 36.6434 10.1213L36.9693 10.7352C36.5724 10.8441 36.4215 11.1046 36.3715 11.2176C36.3162 11.3426 36.2629 11.5111 36.3352 11.6854C36.3816 11.8056 36.4696 11.8801 36.5647 11.9222C36.6837 11.9749 36.7881 11.9642 36.9128 11.8913C36.998 11.8436 37.0877 11.7695 37.3727 11.5115C37.5852 11.3209 37.8101 11.0861 38.096 10.9707C38.393 10.8461 38.6824 10.8675 38.968 10.9939C39.3487 11.1625 39.5929 11.4627 39.6964 11.7433C39.7959 12.0008 39.8069 12.2974 39.7465 12.5624L40.4128 12.8573L40.1968 13.3452L39.5424 13.0555C39.3592 13.3728 39.121 13.5733 38.9342 13.6899C38.7758 13.7905 38.5705 13.8846 38.3077 13.9319L38.0471 13.2829C38.1944 13.2556 38.407 13.1932 38.5542 13.1018C38.7357 12.9972 38.8656 12.8484 38.9604 12.6342C39.0289 12.4795 39.0729 12.2998 39.0059 12.1136C38.9496 11.9677 38.8338 11.8595 38.7029 11.8015C38.5542 11.7357 38.4155 11.7597 38.3151 11.7935C38.2148 11.8273 37.9661 12.0517 37.8935 12.1191C37.7431 12.266 37.4079 12.573 37.0851 12.7076C36.8224 12.8189 36.5925 12.8239 36.2772 12.6843C36.0154 12.5684 35.7998 12.3805 35.6699 12.0953C35.5884 11.9098 35.5173 11.6364 35.5862 11.304L34.9912 11.0406Z"
        fill="#F2D497"
      />
      <rect
        x="28.342"
        y="11.4535"
        width="20.1439"
        height="3.54047"
        transform="rotate(31.258 28.342 11.4535)"
        fill="#F9E4B9"
      />
    </svg>
  );
};

export default RebateIcon;
